export const billingInvoicesHandler = {
    pathPattern: '/brands/:brandId/billing/invoices/:invoiceId',
    toWeb: ({ brandId, invoiceId }) => ({
        path: `/brands/${brandId}/billing/invoices/${invoiceId}`,
    }),
    meta: {
        title: 'Billing invoice',
        description: 'Opens a billing invoice in the operator dashboard.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'invoiceId', in: 'path', required: true },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId', invoiceId: 'exampleInvoiceId' },
        },
    },
};
//# sourceMappingURL=billing-invoices.js.map